import { Directive, inject, TemplateRef } from '@angular/core';

/** The card's content; built only while the card is open. */
@Directive({ selector: 'ng-template[hoverCardContent]' })
export class HoverCardContentDirective {
  public readonly template = inject<TemplateRef<unknown>>(TemplateRef);
}
